export let style = { position: 'absolute', top: 0, left: 0, zIndex: -1, width: window.innerWidth, height: window.innerHeight }
